import BaseViewController from "./base-view-controller";
import { mapPhoneButton } from "../utils/medical-info-utils";
import { getFlow } from "../api/flow";
import { buildPharmacies } from "../utils/pharmacy-builder";
import { FIELD_NAMES, SCREEN_PARAMS } from "../utils/constants";

class PharmacyDetailViewController extends BaseViewController {
  preprocessScreenData() {
    const { fields } = this.screen;
    const { values } = this.appData;
    mapPhoneButton(
      fields,
      values,
      "pharmacy_phone_button",
      "phone_faxes.0.phone_number"
    );
    mapPhoneButton(
      fields,
      values,
      "pharmacy_fax_button",
      "phone_faxes.1.phone_number"
    );
  }

  handleButtonClick(name, text, action) {
    if (name === FIELD_NAMES.removeButton) {
      getFlow({
        url: action.value,
        formState: this.prepareSubmit({
          member_id: this.appData.values.logged_in_member_id,
          selectedData: {
            pharmacy_id: this.appData.values.selectedData.pharmacy_id,
            member_pharmacy_relation_id:
              this.appData.values.selectedData.member_pharmacy_relation_id
          }
        })
      }).then(res => {
        const pharmacyListScreen = this.appData.data.screens.find(screen =>
          (screen.params || "").includes(SCREEN_PARAMS.screenOptionPharmacyList)
        );
        const pharmacies = res.data;
        pharmacyListScreen.fields = [
          pharmacyListScreen.fields[0],
          ...buildPharmacies({ pharmacies })
        ];
        this.appData.prevScreen();
      });
    } else {
      super.handleButtonClick(name, text, action);
    }
  }
}

export default PharmacyDetailViewController;
